<template>
  <div class="fin__container">
    <div class="fin__inner">
      <Logo />
      <div class="form__container">
        <div class="payment__title">Thank you!</div>
        <div class="payment__subtitle">Your trial has begun. You will receive a confirmation email shortly.</div>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/Logo.vue";

export default {
  components: { Logo }
}
</script>